import { cn } from '@/shared/ui/cn';

export type BrandLogoProps = {
  /** Hauteur de l'emblème, en pixels. 32 : le standard des barres. */
  size?: number;
  /** Affiche « BUL » à côté de l'emblème. */
  wordmark?: boolean;
  className?: string;
};

/**
 * Marque BUL : partout la même. L'emblème recadré au plus près (le bouclier et
 * son anneau d'or), et le mot « BUL » en Inter Medium, jamais redessiné.
 */
export function BrandLogo({ size = 32, wordmark = false, className }: BrandLogoProps) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <img
        src="/brand/logo-bul-mark.png"
        alt="BUL"
        width={size}
        height={size}
        draggable={false}
        className="shrink-0 select-none"
        style={{ width: size, height: size }}
      />
      {wordmark ? (
        <span aria-hidden className="text-title2 tracking-[-0.04em] text-fg">
          BUL
        </span>
      ) : null}
    </span>
  );
}
